<template>
	<div class="jiedaiOrder" :style="{
		'padding-top': paddingTop + 'px',
		'padding-bottom': paddingBottom + 'px',
	}">
		<div class="radioBox" ref="radioBox">
			<span style="font-size: 14px;">订单类型：</span>
			<el-select v-model="orderType" @change="changeOrderType" :disabled="mergeState" placeholder="请选择"
				size="mini" style="width:110px;">
				<el-option v-for="item in [
					{ value: '', label: '全部订单' },
					{ value: '1', label: '商品订单' },
					{ value: '3,4,5,7', label: '医疗订单' },
					{ value: '2', label: '洗美订单' },
					{ value: '6', label: '寄养订单' },
					{ value: '8', label: '活体订单' },
					{ value: '9', label: '虚拟订单' },
					{ value: '10', label: '订金订单' },
				]" :key="item.value" :label="item.label" :value="item.value"></el-option>
			</el-select>
			<span style="font-size: 14px;padding-left:20px;">订单状态：</span>
			<el-select v-model="radio" @change="changeRadio" :disabled="mergeState" placeholder="请选择" size="mini"
				style="width:110px;">
				<el-option v-for="item in [
					{ value: '', label: '全部' },
					{ value: '1,2', label: '待结算' },
					{ value: '3', label: '已结算' },
					{ value: '-2', label: '已取消' },
				]" :key="item.value" :label="item.label" :value="item.value"></el-option>
			</el-select>
			<!-- <span style="font-size: 14px;padding-left:20px;margin-right: 6px;">合并支付筛选</span>
			<el-checkbox v-model="mergeState" @change="changeMergeState"></el-checkbox> -->
			<el-button v-show="mergeState" type="warning" size="mini" style="margin-left:30px;"
				@click="clickMerge">合并支付</el-button>
			<div v-show="mergeState" class="userBox">
				<div class="userItem" :class="[curUserItem.user_id === user.user_id ? 'active' : '']"
					@click="clickUserItem(user)" v-for="user in userList" :key="user.user_id">
					{{
						user.nick_name.length > 4
							? user.nick_name.substr(0, 4) + "..."
							: user.nick_name
					}}
					{{ user.user_mobile.substr(7, 4) }}
				</div>
			</div>
		</div>
		<!-- 合并支付 -->
		<div v-if="tableState && mergeState" style="width:100%;height: 100%;">
			<el-table :data="tableData_merge" height="100%" style="width: 100%;" ref="tableData"
				:header-row-class-name="'tableTitBg'">
				<el-table-column label width="35">
					<template slot-scope="scope">
						<el-checkbox v-model="scope.row.checked" :disabled="scope.row.disabled"></el-checkbox>
					</template>
				</el-table-column>
				<el-table-column label="状态" width="80">
					<template slot-scope="scope">{{
						$public.formatOrderState(scope.row.state)
					}}</template>
				</el-table-column>
				<el-table-column label="创建时间" width="140">
					<template slot-scope="scope">{{
						$public.FTime(scope.row.create_time, "YYYY-MM-DD HH:mm")
					}}</template>
				</el-table-column>
				<el-table-column label="订单类型" width="80">
					<template slot-scope="scope">
						{{ scope.row.order_type_id == 1 ? "商品" : "" }}
						{{ scope.row.order_type_id == 2 ? "洗美" : "" }}
						{{ scope.row.order_type_id == 3 ? "病例" : "" }}
						{{ scope.row.order_type_id == 4 ? "疫苗驱虫" : "" }}
						{{ scope.row.order_type_id == 5 ? "医疗服务" : "" }}
						{{ scope.row.order_type_id == 6 ? "寄养" : "" }}
						{{ scope.row.order_type_id == 7 ? "挂号" : "" }}
						{{ scope.row.order_type_id == 8 ? "活体" : "" }}
						{{ scope.row.order_type_id == 9 ? "虚拟类" : "" }}
						{{ scope.row.order_type_id == 10 ? "订金" : "" }}
					</template>
				</el-table-column>
				<el-table-column prop="memberName" label="姓名" width="100">
					<template slot-scope="scope">{{
						scope.row.user_info.nick_name
					}}</template>
				</el-table-column>
				<el-table-column prop="memberName" label="手机号" width="110">
					<template slot-scope="scope">{{
						scope.row.user_info.user_mobile
					}}</template>
				</el-table-column>
				<el-table-column prop="petName" label="宠物" width="90">
					<template slot-scope="scope">
						<div v-for="(item, index) in getPetList(scope.row.order_item_list)" :key="index">
							{{ item.split("bind")[0] }}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="linkId" label="订单号">
					<template slot-scope="scope">
						<div>
							<span>{{ scope.row.no }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="订单总额" width="80">
					<template slot-scope="scope">{{ scope.row.total_price }}</template>
				</el-table-column>
				<el-table-column label="操作" width="150">
					<template slot-scope="scope">
						<el-button type="text" @click="see(scope.row)" size="small">查看</el-button>
						<el-button v-if="scope.row.state == 1 || scope.row.state == 2" @click="pay(scope.row)"
							type="text" size="small">结算</el-button>
						<el-button v-if="
							(scope.row.state == 1 || scope.row.state == 2) &&
							scope.row.state != -2
						" @click="cancel(scope.row._id)" type="text" size="small">取消订单</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- 不合并支付 -->
		<div v-if="tableState && !mergeState" style="width:100%;height: 100%;">
			<el-table :data="tableData" height="100%" style="width: 100%;" ref="tableData">
				<el-table-column label="状态" width="80">
					<template slot-scope="scope">{{
						$public.formatOrderState(scope.row.state)
					}}</template>
				</el-table-column>
				<el-table-column label="创建时间" width="140">
					<template slot-scope="scope">{{
						$public.FTime(scope.row.create_time, "YYYY-MM-DD HH:mm")
					}}</template>
				</el-table-column>
				<el-table-column label="订单类型" width="80">
					<template slot-scope="scope">
						{{ scope.row.order_type_id == 1 ? "商品" : "" }}
						{{ scope.row.order_type_id == 2 ? "洗美" : "" }}
						{{ scope.row.order_type_id == 3 ? "病例" : "" }}
						{{ scope.row.order_type_id == 4 ? "疫苗驱虫" : "" }}
						{{ scope.row.order_type_id == 5 ? "医疗服务" : "" }}
						{{ scope.row.order_type_id == 6 ? "寄养" : "" }}
						{{ scope.row.order_type_id == 7 ? "挂号" : "" }}
						{{ scope.row.order_type_id == 8 ? "活体" : "" }}
						{{ scope.row.order_type_id == 9 ? "虚拟类" : "" }}
						{{ scope.row.order_type_id == 10 ? "订金" : "" }}
					</template>
				</el-table-column>
				<el-table-column prop="memberName" label="姓名" width="100">
					<template slot-scope="scope">{{
						scope.row.user_info.nick_name
					}}</template>
				</el-table-column>
				<el-table-column prop="memberName" label="手机号" width="110">
					<template slot-scope="scope">{{
						scope.row.user_info.user_mobile
					}}</template>
				</el-table-column>
				<el-table-column prop="petName" label="宠物" width="90">
					<template slot-scope="scope">
						<div v-for="(item, index) in getPetList(scope.row.order_item_list)" :key="index">
							{{ item.split("bind")[0] }}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="linkId" label="订单号">
					<template slot-scope="scope">
						<div>
							<span>{{ scope.row.no }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="订单总额" width="80">
					<template slot-scope="scope">{{ scope.row.total_price }}</template>
				</el-table-column>
				<el-table-column label="操作" width="150">
					<template slot-scope="scope">
						<el-button type="text" @click="see(scope.row)" size="small">查看</el-button>
						<el-button v-if="scope.row.state == 1 || scope.row.state == 2" @click="pay(scope.row)"
							type="text" size="small">结算</el-button>
						<el-button v-if="
							(scope.row.state == 1 || scope.row.state == 2) &&
							scope.row.state != -2
						" @click="cancel(scope.row._id)" type="text" size="small">取消订单</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pageBox">
				<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
			</div>
		</div>
		<orderSee v-if="drawerActivitySee_state" :curItem="curItem" @submit="submit_drawerActivitySee"></orderSee>
		<!-- 结算 -->
		<div v-if="dialogSettlementState">
			<dialogSettlement :type="settlement_type" :orderId="curOrder._id" @submit="dialogSettlementSubmit">
			</dialogSettlement>
		</div>
	</div>
</template>
<script>
import page from "../../../../../components/page.vue";
import dialogSettlement from "../../../../../components/dialog_settlement.vue";
import orderSee from "../../drawer/orderSee.vue";
export default {
	components: { page, dialogSettlement, orderSee },
	data() {
		return {
			orderType: "",
			radio: "",
			tableData: [],
			page: {
				page: 1,
				pageSize: 10,
				total: 0,
			},
			// 查看
			drawerActivitySee_state: false,
			curItem: {},
			// 结算
			dialogSettlementState: false,
			curOrder: {},
			// 合并支付
			settlement_type: "order",
			tableData_merge: [],
			tableState: true,
			mergeState: false,
			paddingTop: 48,
			paddingBottom: 50,
			curUserItem: {},
			userList: [],
		};
	},
	computed: {
		curShopId() {
			return this.$store.state.shopId;
		},
	},
	mounted() {
		this.getTableData();
	},
	methods: {
		// 合并支付
		changeMergeState() {
			this.getTableData("merge");
			if (this.mergeState === true) {
				this.$nextTick(() => {
					this.paddingTop = this.$refs.radioBox.clientHeight;
					this.paddingBottom = 0;
					this.tableState = false;
					this.$nextTick(() => {
						this.tableState = true;
					});
				});
			} else {
				this.paddingTop = 48;
				this.paddingBottom = 50;
				this.tableState = false;
				this.$nextTick(() => {
					this.tableState = true;
				});
				this.orderType = "";
				this.radio = "";
				this.getTableData();
			}
		},
		clickUserItem(userItem) {
			let isCheck = false;
			this.curUserItem = userItem;
			let tableData = [];
			for (let i = 0; i < this.tableData.length; i++) {
				this.$set(this.tableData[i], "checked", true);
				this.$set(this.tableData[i], "disabled", false);
				if (userItem.user_id === this.tableData[i].user_info.user_id) {
					tableData.push(this.tableData[i]);
				}
			}
			let doubleGoodsAndLiving = 0;
			for (let i = 0; i < tableData.length; i++) {
				if (tableData[i].order_type_id === 8) {
					doubleGoodsAndLiving += 2;
				} else {
					doubleGoodsAndLiving += 1;
				}
			}

			for (let i = 0; i < tableData.length; i++) {
				if (
					tableData[i].order_type_id === 8 &&
					doubleGoodsAndLiving !== tableData.length
				) {
					tableData[i].disabled = true;
					tableData[i].checked = false;
				} else if (tableData[i].order_type_id === 2) {
					isCheck = tableData[i].order_item_list.some((item) => {
						return (
							item.activity_info && item.activity_info.pay_type.includes("11")
						);
					});
					tableData[i].disabled = isCheck;
					tableData[i].checked = !isCheck;
				} else {
					tableData[i].disabled = false;
					tableData[i].checked = true;
				}
			}
			this.tableData_merge = tableData;
		},
		clickMerge() {
			let arr = [],
				arrTable = [];
			for (let i = 0; i < this.tableData_merge.length; i++) {
				if (this.tableData_merge[i].checked === true) {
					arrTable.push(this.tableData_merge[i]);
					arr.push(this.tableData_merge[i].no);
				}
			}
			if (this.$public.isNull(arr)) {
				this.$message({
					message: "没有要结算的订单",
					type: "error",
				});
				return;
			}
			let arr_code = this.$public.sameCodeAtMergeOrder(arrTable);
			if (arr_code.length > 0) {
				this.$message({
					message:
						"合并订单中含有相同条码：" +
						arr_code.join(",") +
						"，不能进行合并操作！！",
					type: "error",
				});
				return;
			}
			this.$confirm("确定要合并支付吗?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				let loading = this.$loading();
				this.$http.post("/api/Order/MergeOrder", arr).then((res) => {
					loading.close();
					if (res.code == 0) {
						this.settlement_type = "mergeOrder";
						this.curOrder = res.data;
						this.curOrder._id = this.curOrder.merge_order_no;
						this.dialogSettlementState = true;
					}
				});
			});
		},
		// changeOrderType
		changeOrderType() {
			this.page.page = 1;
			this.getTableData();
		},
		// changeRadio
		changeRadio() {
			this.page.page = 1;
			this.getTableData();
		},
		// 查看
		see(row) {
			this.curItem = row;
			this.drawerActivitySee_state = true;
		},
		submit_drawerActivitySee() {
			this.drawerActivitySee_state = false;
		},
		// 结算
		pay(row) {
			this.settlement_type = "order";
			this.curOrder = row;
			this.dialogSettlementState = true;
		},
		dialogSettlementSubmit(a) {
			this.dialogSettlementState = false;
			if (a == "close") {
				console.log(a);
			} else if (a == "fail") {
				this.$message({
					message: "结算失败",
					type: "error",
				});
			} else if (a == "success") {
				this.$message({
					message: "结算成功",
					type: "success",
				});
			}
			if (this.mergeState === true) {
				this.getTableData("merge");
			} else {
				this.getTableData();
			}
		},
		// 取消订单
		cancel(id) {
			this.$confirm("确定取消该订单?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				this.$http
					.get("/api/Order/ReceivedOrder", {
						order_id: id,
					})
					.then((res) => {
						if (res.code == 0) {
							this.$message({
								message: "取消成功",
								type: "success",
							});
							if (this.mergeState === true) {
								this.getTableData("merge");
							} else {
								this.getTableData();
							}
						}
					});
			});
		},
		changePage(num) {
			this.page.page = num;
			this.getTableData();
		},
		// 获取列表数据
		getTableData(str) {
			if (str === "merge") {
				this.orderType = "";
				this.radio = "1,2";
				this.page.page = 1;
				this.page.pageSize = 100;
			} else {
				this.page.pageSize = 10;
			}
			let curDay = this.$public.FTime(new Date().getTime(), "YYYY-MM-DD");
			let params = {
				keyword: "", //关键词
				userid: "", // 用户id
				pet_id: "", //宠物id
				starttime: ("" + (new Date(curDay).getTime() - 28800000)).substr(0, 10), //开始时间
				endtime: (
					"" +
					(new Date(curDay).getTime() + 86400000 - 28800000)
				).substr(0, 10), //结束时间
				pay_starttime: "", //支付开始时间
				pay_endtime: "", //支付结束时间
				state: this.radio, //状态
				pay_type: "", // 支付方式
				create_manager_id: "", //创建人id
				order_type: "", //订单类型
				order_type_id: this.orderType, //订单类型id
				sales_id: "", //销售人员id
				pageIndex: this.page.page,
				pageSize: this.page.pageSize,
			};
			let loading = this.$loading();
			this.$http.post("/api/Order/OrderList", params).then((res) => {
				loading.close();
				if (res.code == 0) {
					this.tableData = res.data.data;
					this.tableData_merge = res.data.data;
					this.page.total = res.data.count;
					if (str === "merge") {
						for (let i = 0; i < this.tableData.length; i++) {
							let state = true;
							for (let a = 0; a < this.userList.length; a++) {
								if (
									this.userList[a].user_id ===
									this.tableData[i].user_info.user_id
								) {
									state = false;
								}
							}
							if (state === true) {
								this.userList.push({
									user_id: this.tableData[i].user_info.user_id,
									user_mobile: this.tableData[i].user_info.user_mobile,
									nick_name: this.tableData[i].user_info.nick_name,
								});
							}
						}
						if (!this.$public.isNull(this.userList)) {
							if (this.$public.isNull(this.curUserItem.user_id)) {
								this.clickUserItem(this.userList[0]);
							} else {
								this.clickUserItem(this.curUserItem);
							}
						}
						if (this.mergeState === true) {
							this.$nextTick(() => {
								this.paddingTop = this.$refs.radioBox.clientHeight;
								this.paddingBottom = 0;
								this.tableState = false;
								this.$nextTick(() => {
									this.tableState = true;
								});
							});
						} else {
							this.paddingTop = 48;
							this.paddingBottom = 50;
							this.tableState = false;
							this.$nextTick(() => {
								this.tableState = true;
							});
						}
					}
				}
			});
		},
		// 筛选订单包含的宠物
		getPetList(list) {
			let arr = [];
			for (let i = 0; i < list.length; i++) {
				if (list[i].pets_info) {
					if (
						arr.indexOf(
							list[i].pets_info.pets_name + "bind" + list[i].pets_info.pets_id
						) === -1
					) {
						arr.push(
							list[i].pets_info.pets_name + "bind" + list[i].pets_info.pets_id
						);
					}
				}
			}
			return arr;
		},
	},
};
</script>
<style scoped lang="scss">
.jiedaiOrder {
	width: 100%;
	height: 100%;
	padding-bottom: 50px;
	box-sizing: border-box;
	padding-top: 34px;
	position: relative;

	.radioBox {
		padding: 10px 30px 6px;
		position: absolute;
		z-index: 1;
		top: 0;
		width: 100%;
		box-sizing: border-box;

		.userBox {
			display: flex;
			flex-wrap: wrap;
			width: 100%;
			padding: 15px 20px 0;

			.userItem {
				background-color: #fff;
				line-height: 26px;
				border: 1px solid rgba(0, 0, 0, 0.15);
				padding: 0 15px;
				color: rgba(0, 0, 0, 0.65);
				cursor: pointer;
				font-size: 14px;
				margin-right: 10px;

				&.active {
					color: #fff;
					background-color: $mainColor;
					border-color: $mainColor;
				}
			}
		}
	}

	.pageBox {
		// padding:20px;
	}
}
</style>
